import { ResetUserPasswordRequestDto } from '@docbay/schemas';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { UserResetPasswordActions } from 'application/constants/actions';
import { AxiosError } from 'axios';
import { UserResetPassword } from 'integration/api/userResetPassword';

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Resets a user's password.
 * @param params - The request payload containing the user's ID and new password.
 * @returns A promise that resolves to the response data from the API call,
 *          or rejects with an error message if the API call fails.
 */
export const resetPassword = createAsyncThunk(
  UserResetPasswordActions.resetPassword,
  async (params: ResetUserPasswordRequestDto, { rejectWithValue }) => {
    try {
      const { data } = await UserResetPassword.resetPassword(params);
      await delay(1000);

      return data;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error.message);
    }
  },
);
